import * as React from "react";
const SvgFiRrTaco = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-taco_svg__a)">
      <path
        fill="#062147"
        d="M18 15a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m3 1a1 1 0 1 0 2 0 1 1 0 0 0-2 0m4.988-7.732c1.257 2.14 1 5.337 1.012 7.732a5.006 5.006 0 0 1-5 5H3.5A3.5 3.5 0 0 1 0 19.5c.026-3.511-.523-8.3 2.063-11.123a1 1 0 0 1 1.563 1.247A7.5 7.5 0 0 0 2 14.274V19.5a1.5 1.5 0 0 0 3 0c.05-2.675-.358-6.812 1.044-9.17C4.647 7.908 4.177 3.9 8.257 3.064a3.315 3.315 0 0 1 3.8-1.947 3.23 3.23 0 0 1 4.918-.011 3.31 3.31 0 0 1 3.768 1.958c4.017.828 3.644 4.737 2.245 7.205M7.356 8.35a9.46 9.46 0 0 1 14.316-.08C22.353 6.658 21.983 5.073 20 5a1 1 0 0 1-.98-.8A1.464 1.464 0 0 0 17.688 3a1.7 1.7 0 0 0-.583.2 1 1 0 0 1-1.241-.317c-.981-1.261-1.815-1.153-2.7.025a1 1 0 0 1-1.242.317A2 2 0 0 0 11.337 3 1.49 1.49 0 0 0 9.98 4.2 1 1 0 0 1 9 5c-2.032.073-2.348 1.729-1.644 3.35M22 14.5c-.377-10.04-14.77-9.888-15 .29-.088 1.113.267 5.25-.338 6.21H19a3 3 0 0 0 3-3z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-taco_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTaco;
